// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__PHQa4","page":"Layout_page__36k7H"};